import { useQuery } from '@tanstack/react-query';
import { erpApi } from '@/shared/axios/erp-api';
import { urlBackend } from '@/shared/constants';
import type { IDocumentosContrato } from '@/shared/interfaces/erp/tickets-soporte-clientes';

const { get } = erpApi();
const BASE_URL = `${urlBackend}api/v1/gestion-tickets/contratos/`;

// Key propia, fuera de ['vision-360']: crear tickets o bajas de aprovisionamiento
// invalidan ['vision-360'] y no deben volver a consultar Softnet (hasta 30s).
// staleTime alto por lo mismo: cambiar de tab o de contrato reutiliza la cache.
export const useQueryDocumentosContrato = (idContrato?: string) =>
  useQuery({
    queryKey: ['vision-360-documentos', idContrato],
    queryFn: async () =>
      get<IDocumentosContrato>(`${BASE_URL}${idContrato}/documentos`, true),
    enabled: !!idContrato,
    staleTime: 5 * 60_000,
  });
